import { useState } from 'react';

import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from '@mui/material';

import { openSnackbar } from '../store/slices/SnackbarSlice';

import { NuevaListaAcuerdos } from '../connections/tribunal/ListaAcuerdoConnection';

interface Props {
    openDialog: boolean;
    handleCloseDialog: () => void;
}

type TipoBusquedaType = '' | 'Generar nueva lista de acuerdos' | 'Consultar listas de acuerdos';

export const DialogNuevaListaAcuerdos = ({ openDialog, handleCloseDialog }: Props) => {

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const [tipoBusqueda, setTipoBusqueda] = useState<TipoBusquedaType>( '' );

    const handleGenerarListaAcuerdos = async () => {

        setLoadingGuardar( true );

        if ( tipoBusqueda === 'Generar nueva lista de acuerdos' ) {

            await NuevaListaAcuerdos().then( resp => {

                const { idListaAcuerdo, success, message } = resp;

                if ( success ) {

                    setTimeout(() => {

                        setLoadingGuardar( false );

                        navigate(`/tribunal/lista-acuerdos/generar/${idListaAcuerdo}`);

                    }, 700);

                }
                else {

                    setTimeout(() => {

                        setLoadingGuardar( false );

                        dispatch( openSnackbar({ message: message, variant: 'error' }) );

                    }, 700);
                }

            })

        }
        else if ( tipoBusqueda === 'Consultar listas de acuerdos' ) {

            setTimeout(() => {

                setLoadingGuardar( false );

                navigate('/tribunal/lista-acuerdos/consultar/');

            }, 700);

        }
    }

    const handleCerrarDialog = () => {

        setTipoBusqueda( '' );
        handleCloseDialog();

    }

    return (
        <>

            <Dialog
                fullWidth
                maxWidth='md'
                open={ openDialog }
            >

                <DialogTitle>Lista de acuerdos</DialogTitle>

                <DialogContent>

                    <Grid container spacing={3} mt={1}>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl>

                                <FormLabel>Seleccione una opción:</FormLabel>
                                <RadioGroup row>

                                    <FormControlLabel
                                        label='Generar nueva lista de acuerdos'
                                        control={
                                            <Radio
                                                checked={ tipoBusqueda === 'Generar nueva lista de acuerdos' }
                                                onChange={ () => setTipoBusqueda( 'Generar nueva lista de acuerdos' ) }
                                            />
                                        }
                                    />

                                    <FormControlLabel
                                        label='Consultar listas de acuerdos'
                                        control={
                                            <Radio
                                                checked={ tipoBusqueda === 'Consultar listas de acuerdos' }
                                                onChange={ () => setTipoBusqueda( 'Consultar listas de acuerdos' ) }
                                            />
                                        }
                                    />

                                </RadioGroup>

                            </FormControl>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions>

                    <Button color='secondary' disabled={ loadingGuardar } onClick={ handleCerrarDialog }>Cancelar</Button>

                    <Button
                        variant="contained"
                        loading={ loadingGuardar }
                        disabled={ tipoBusqueda === '' }
                        onClick={ handleGenerarListaAcuerdos }
                    >
                        Guardar
                    </Button>

                </DialogActions>

            </Dialog>

        </>
    )
}
